import { defineComponent as _defineComponent } from 'vue'
import { PaginatedQuery, ClientIntegration, integrationStateLabels } from 'ah-api-gateways';
import { computed, PropType } from 'vue';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { VButton } from 'ah-common-lib/src/common/components';
import { useToast } from 'ah-common-lib/src/toast';

interface OnboardedClientsEmit extends UseManagedListingEmits<ClientIntegration> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'IntegrationsListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({
      tableFields: [
        {
          header: 'Type',
          key: 'integration',
        },
        {
          header: 'State',
          key: 'state',
        },
        {
          header: 'Key',
          key: 'resourceKey',
        },
        {
          header: '',
          key: 'actions',
        },
      ],
    }),
  },
  ...defineUseManagedListingProps<ClientIntegration>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const services = getServices();



const toast = useToast();

const reqManager = useRequestManager().manager;

const managedListing = useManagedListing<ClientIntegration>({
  loadDataRequest(query: PaginatedQuery) {
    return services.integrations.listIntegrations(query);
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager,
});

function deleteIntegration(integration: ClientIntegration) {
  reqManager
    .currentOrNew(`delete-${integration.id}`, services.integrations.deletePlaidPublicToken(integration.id))
    .subscribe(() => {
      toast.success('Deleted integration');
      managedListing.loadData();
    });
}

expose({ loadData: managedListing.loadData });

return { __sfc: true,props, services, emit, toast, reqManager, managedListing, deleteIntegration, integrationStateLabels, VButton }
}

})